import React from 'react';
import { Card } from 'antd';

export default class ResponsiveCard extends Card {
    state = {
        cardSize: "default",
    }

    componentWillMount = () => {
        window.addEventListener("resize", this.onResize);
        this.onResize();
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.onResize);
    }

    onResize = () => {
        let state = {...this.state};
        let width = window.innerWidth;

        if (width <= 800) {
            state.cardSize = "small";
        } else {
            state.cardSize = "default";
        }

        this.setState(state);
    }

    render() {
        return <Card {...this.props} size={this.state.cardSize}/>
    }
}